import React from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/FormElements/Button";
import Help from "./Help";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import EducationYearSelector from "components/shared/selectors/EducationYearSelector";

const LayoutHeader = ({
  itemType,
  selectedItemId,
  onNewItem,
  onBulkProcess,
  showSelectedYear,
  hideCreateNewItem,
  hideCreateNewItemWhenSelected,
  showImportSpreadsheet,
  standardHelpItems,
  highlightedHelpItems,
  isFullScreen,
  onClose,
  onFullScreen,
  onHalfScreen,
  isMobile,
  isAlwaysFullScreen,
  isNewItem,
  isBulkProcess,
  hasBulkProcessComponent,
}) => {
  const { t } = useTranslation();

  const fullScreenHandler = () => {
    if (isFullScreen) {
      onHalfScreen();
    } else {
      onFullScreen();
    }
  };

  const shouldShowNewButton =
    !hideCreateNewItem && (selectedItemId ? !hideCreateNewItemWhenSelected : true) && !isNewItem && !isBulkProcess;
  const shouldShowImportButton = shouldShowNewButton && showImportSpreadsheet;
  const shouldShowBulkProcessButton =
    hasBulkProcessComponent &&
    onBulkProcess &&
    !hideCreateNewItem &&
    (selectedItemId ? !hideCreateNewItemWhenSelected : true) &&
    !isNewItem &&
    !isBulkProcess;
  const shouldShowResizeButton = (selectedItemId || isNewItem || isBulkProcess) && !isMobile && !isAlwaysFullScreen;
  const shouldShowHelpButton = Boolean(standardHelpItems || highlightedHelpItems);
  const showRightHandElements =
    Boolean(selectedItemId) || shouldShowResizeButton || shouldShowHelpButton || isNewItem || isBulkProcess;

  return (
    <div className="layout-navigation">
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
        {shouldShowNewButton && (
          <Button danger size="small" onClick={onNewItem}>
            {t(`${itemType}.createNewItem`)}
          </Button>
        )}
        {shouldShowImportButton && (
          <Button size="small" to="/start">
            {t(`${itemType}.importSpreadsheet`)}
          </Button>
        )}

        {shouldShowBulkProcessButton && (
          <Button danger size="small" onClick={onBulkProcess}>
            {t(`${itemType}.createBulkProcess`)}
          </Button>
        )}
      </div>

      {showSelectedYear && <EducationYearSelector style={{ marginLeft: "auto" }} />}

      {showRightHandElements && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: !isFullScreen ? "space-between" : "space-between",
            columnGap: "10px",
            width: "100%",
          }}
        >
          <div>
            {(selectedItemId || isNewItem || isBulkProcess) && (
              <Button type="button" size="small" danger onClick={onClose}>
                &#60; {t("close")}
              </Button>
            )}
          </div>

          <div style={{ display: "flex", flexDirection: "row", columnGap: "10px" }}>
            {shouldShowResizeButton && (
              <Button type="button" size="icon" danger onClick={fullScreenHandler}>
                {!isFullScreen ? <FullscreenIcon /> : <FullscreenExitIcon />}
              </Button>
            )}

            {shouldShowHelpButton && (
              <Help standardHelpItems={standardHelpItems} highlightedHelpItems={highlightedHelpItems} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LayoutHeader;
